module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/sakae_point3_2-611ba5e297599f962f2e150eb7483f36.jpg";